import React from "react";
import SkeyechartDatasourcesTable from "./SkeyechartDatasourcesTable";
import { fetchDataSources } from "./SkeyechartDatasourcesAPI";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import skeyechartsDatasourcesHelp from "../../../content/help/skeyecharts-datasources.json";

export default function SkeyechartsDatasources({
  pageTitle = "Skeyechart Datasources",
}) {
  usePageTitle("SkeyeCharts Datasources - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    contextHolder,
    handleSearch,
    clearFilter,
    onPageChange,
  } = usePageState({
    fetchFn: fetchDataSources,
    filterFields: [(d) => d.id?.toString(), "backend", "database_name"],
  });

  return (
    <div className="skeyecharts-datasources-page">
      {contextHolder}
      <PageLayout
        title={pageTitle}
        logo="/img/majesteye-icon-skeye-charts-square-white-background-no-label"
        description="Manager for Skeyecharts datasources, allowing you to view your data connections in one place."
        helpContent={skeyechartsDatasourcesHelp}
      >
        <SearchToolbar
          search={searchText}
          onSearchChange={handleSearch}
          onClearFilter={clearFilter}
        />

        <SkeyechartDatasourcesTable
          data={filteredData}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
        />
      </PageLayout>
    </div>
  );
}
